module.exports = __webpack_public_path__ + "static/media/officeladies.e3e7bad3.jpg";